import Vue from "vue";
import { BootstrapVue,BootstrapVueIcons } from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import Vuelidate from "vuelidate";
import * as VueGoogleMaps from "vue2-google-maps";
import VueMask from "v-mask";
import VueRouter from "vue-router";
import VueLuxon from "vue-luxon";
import VueMoment from "vue-moment";
import moment from "moment";
import VueLodash from "vue-lodash";
import vco from "v-click-outside";
import router from "./router/index";
import Scrollspy from "vue2-scrollspy";
import VueSweetalert2 from "vue-sweetalert2";
import { ValidationObserver, ValidationProvider, extend, configure } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import PhoneNumber from "awesome-phonenumber";
import lodash from "lodash";
import VueSelect from "vue-select";
import { registerAllModules } from "handsontable/registry";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import Editor from "@tinymce/tinymce-vue";
import FloatingVue from "floating-vue";
import Toast from "vue-toastification";

import "vue-toastification/dist/index.css";
import "floating-vue/dist/style.css";
import "../src/design/app.scss";

import store from "@/state/store";

import App from "./App.vue";

import { initFirebaseBackend } from "./authUtils";
import i18n from "./i18n";

import { configureFakeBackend } from "./helpers/fake-backend";

import tinymce from "vue-tinymce-editor";

import Axios from "./plugins/axios";
import Auth from "./plugins/auth";
import Numeral from "./plugins/numeral";
import PreviewImagePdf from "@/components/inputs/preview-image-pdf";
import DeliveryMap from "@/components/inputs/delivery-map";
import GroupRow from "@/components/models/show/group-row";
import Attachment from "@/router/views/trips/components/attachment.vue";
import PaymentBadge from "@/components/badges/payment-badge.vue";
import StatusBadge from "@/components/badges/status-badge.vue";
import EditButton from "@/components/buttons/edit-button.vue";

const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTId,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPId,
  measurementId: process.env.VUE_APP_MEASUREMENTID
};

if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
  initFirebaseBackend(firebaseConfig);
} else {
  configureFakeBackend();
}
Vue.component("tinymce", tinymce);
Vue.use(VueRouter);
Vue.use(vco);
Vue.use(Scrollspy);
const VueScrollTo = require("vue-scrollto");
Vue.use(VueScrollTo);
Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(Vuelidate);
Vue.use(VueMask);
Vue.use(require("vue-chartist"));
Vue.use(require("vue-truncate-filter"));
Vue.use(VueSweetalert2);
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    libraries: "places"
  },
  installComponents: true
});
Vue.component("apexchart", VueApexCharts);

Vue.use(Axios, {
  baseURL: process.env.VUE_APP_API_BASE_URL
});
Vue.use(Auth);
Vue.use(Numeral, {
  locale: process.env.VUE_APP_I18N_LOCALE
});

Vue.use(VueLuxon, {
  input: { format: "sql" },
  output: { locale: document.documentElement.lang }
});

moment.locale(i18n.locale);
Vue.use(VueMoment, { moment });

Vue.use(FloatingVue, {
  themes: {
    "info-tooltip": {
      $extend: "tooltip",
      $resetCss: true
    }
  }
});

lodash.startCase = string => (string || "").replace(/\w+/g, lodash.upperFirst);
Vue.use(VueLodash, { lodash });

Vue.use(Toast, {
  toastClassName: "vista-toast"
});

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});
extend("before_or_equal", {
  validate(value, args) {
    return Vue.prototype.$moment(value).isSameOrBefore(args[0]);
  },
  message: (fieldName, placeholders) => {
    return i18n.t("validation.before_or_equal", {
      _field_: fieldName,
      date: moment(placeholders[0]).format("DD MMM YYYY")
    });
  }
});
extend("after_or_equal", {
  validate(value, args) {
    return Vue.prototype.$moment(value).isSameOrAfter(args[0]);
  },
  message: (fieldName, placeholders) => {
    return i18n.t("validation.after_or_equal", {
      _field_: fieldName,
      date: moment(placeholders[0]).format("DD MMM YYYY")
    });
  }
});

extend("date_between", {
  validate(value, args) {
    const start = Vue.prototype.$moment(args[0]).format("YYYY-MM-DD");
    const end = Vue.prototype.$moment(args[1]).format("YYYY-MM-DD");
    const date = Vue.prototype.$moment(value).format("YYYY-MM-DD");
    return date >= start && date <= end;
  },
  message: (fieldName, placeholders) => {
    return i18n.t("validation.date_between", {
      _field_: fieldName,
      date: moment(placeholders[0]).format("DD MMM YYYY"),
      date2: moment(placeholders[1]).format("DD MMM YYYY")
    });
  }
});

extend('files_mimes', {
    validate: (files, args) => {
        let allowedMimes = args ? args.files_mimes.map(m => m.trim()) : [];
        if (allowedMimes.includes('image/jpeg')) {
            allowedMimes.push('image/jpg');
        }
        if (!Array.isArray(files)) {
            return false;
        }

        if (files.length === 0) {
            return true;
        }
        for (let i = 0; i < files.length; i++) {
            if (files[i]?.id) {
                continue
            }
            let file = files[i];
            let extension = file.name.split('.').pop()?.toLowerCase();
            let allowedExtensions = allowedMimes.map(m => {
                return m.split('/')[1];
            });
            let isAllowedExtension = allowedExtensions.includes(extension);
            let isFile = file?.file instanceof File;
            let isAllowedMime = allowedMimes.includes(file.format);
            if (!isFile || !isAllowedMime || !isAllowedExtension) {
                return false;
            }
        }

        return true;
    },
    params: ['files_mimes'],
    message: (fieldName, placeholders) => {
        const {files_mimes} = placeholders;
        return i18n.t("validation.file_mimes", { _field_: fieldName, type: files_mimes.map(v => v.split('/')[1]).join(', ') });
    }
});

extend('files_required', {
    validate: (files) => {
        if (!Array.isArray(files)) {
            return false
        }
        let filteredFiles = files.filter(f => f._action !== 'delete');
        return filteredFiles.length > 0;
    },
    params: ['files_required'],
    message: (fieldName) => {
        return i18n.t("validation.file_required", { _field_: fieldName});
    }
});

extend("date_in_month", {
  validate(value, args) {
    const diff_value = args[0];
    const diff_unit = "months";
    const start = Vue.prototype.$moment(value[0]);
    const end = Vue.prototype.$moment(value[1]);
    return end.diff(start, diff_unit, true) <= diff_value;
  },
  // eslint-disable-next-line no-unused-vars
  message: (fieldName, placeholders) => {
    return i18n.t("validation.date_in_month", { _field_: fieldName, _value_: `${placeholders[0]}` });
  }
});

extend("phone", {
  validate(value) {
    return new Promise(resolve => {
      let phone = new PhoneNumber(value, "ID");
      resolve({ valid: phone.isValid() });
    });
  }
});
extend("max_value", {
  ...rules.max_value,
  message: (fieldName, placeholders) => {
    return i18n.t("validation.max_value", {
      _field_: fieldName,
      max: Vue.prototype.$numeral(placeholders.max).format("0,0.[00]")
    });
  }
});
extend("gt", {
  validate(value, args) {
    return value > args[0];
  },
  message: (fieldName, placeholders) => {
    return i18n.t("validation.gt", {
      _field_: fieldName,
      _value_: Vue.prototype.$numeral(placeholders[0]).format("0,0.[00]")
    });
  }
});
extend("lte_field", {
  params: ["target"],
  validate(value, { target }) {
    if (value === null || value === undefined || value === "" || target === null || target === undefined || target === "") {
      return true;
    }

    return Number(value) <= Number(target);
  },
  message: (fieldName, placeholders) => {
    return i18n.t("validation.lte_field", {
      _field_: fieldName,
      target: placeholders.target
    });
  }
});
extend("gte_field", {
  params: ["target"],
  validate(value, { target }) {
    if (value === null || value === undefined || value === "" || target === null || target === undefined || target === "") {
      return true;
    }

    return Number(value) >= Number(target);
  },
  message: (fieldName, placeholders) => {
    return i18n.t("validation.gte_field", {
      _field_: fieldName,
      target: placeholders.target
    });
  }
});
extend("password_format", {
  validate(value) {
    let regex = new RegExp(
      "(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])[a-zA-Z0-9!\"#$%&'()*+,\\-./:;<=>?@[\\]^_`{|}~]{6,}",
      "g"
    );
    return regex.test(value);
  }
});
configure({
  defaultMessage: (field, values) => {
    return i18n.t(`validation.${values._rule_}`, values);
  }
});

Vue.component("VueSelect", VueSelect);
Vue.component("PreviewImagePdf", PreviewImagePdf);
Vue.component("DeliveryMap", DeliveryMap);
Vue.component("GroupRow", GroupRow);
Vue.component(VueQrcode.name, VueQrcode);
Vue.component('Editor', Editor);
Vue.component('Attachment', Attachment);
Vue.component('EditButton', EditButton)
Vue.component('PaymentBadge', PaymentBadge);
Vue.component('StatusBadge', StatusBadge);

registerAllModules();

Vue.mixin({
  methods: {
    storageLink(value) {
      if (!value) return;
      return `${process.env.VUE_APP_STORAGE_BASE_URL}/${value}`;
    },
    jalaStorageLink(value) {
      if (!value) return;
      return `${process.env.VUE_APP_STORAGE_JALA_BASE_URL}/${value}`;
    }
  }
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
